import PropTypes from 'prop-types'
import { Input, Label } from 'reactstrap'
import { PER_PAGE_OPTIONS } from 'domains/outbound/deals/constants'

const propTypes = {
  perPage               : PropTypes.string,
  handlePerPageOnChange : PropTypes.func
}

const defaultProps = {
  perPage               : '10',
  handlePerPageOnChange : () => { }
}

/**
 * Field for selecting how much row data will be displayed in 1 page
 * @param {String} perPage - amount of rows data displayed in 1 page
 * @param {Function} handlePerPageOnChange - to handle when user change how much row data will be displayed in 1 page
 */
const OutboundDealsPerPageFilterField = ({
  perPage,
  handlePerPageOnChange
}) => (
  <>
    <Label>{ 'Per Page' }</Label>
    <Input
      name="per_page"
      type='select'
      value={ perPage }
      onChange={ (e) => {handlePerPageOnChange(e)} }
    >
      {
        PER_PAGE_OPTIONS.map((item) => (
          <option
            key={ item.value }
            value={ item.value }
            label = { item.label }
          />
        ))
      }
    </Input>
  </>
)

OutboundDealsPerPageFilterField.propTypes    = propTypes
OutboundDealsPerPageFilterField.defaultProps = defaultProps

export default OutboundDealsPerPageFilterField
